import moment from 'moment-timezone';
import Debug from '@/util/debug';

const debug = Debug('util:add-days');

// Moment's day IDs
const DAY_SATURDAY = 6;
const DAY_SUNDAY = 0;

const toMoment = v => (v instanceof moment ? v : moment(v));
const isWeekend = t => [DAY_SATURDAY, DAY_SUNDAY].indexOf(t.day()) >= 0;
const isHoliday = (t, holidays = []) => !!holidays.filter(h => h.isSame(t, 'day')).length;

export default (rFrom, count, onlyWorking = false, rHolidays = []) => {
  const from = toMoment(rFrom);
  const end = from.clone();
  const holidays = rHolidays.map(toMoment);

  let daysRemaining = count;

  const addedHolidays = [];

  for (/* nothing */; daysRemaining; daysRemaining -= 1) {
    end.add(1, 'day');
    if (onlyWorking) {
      while (isWeekend(end) || isHoliday(end, holidays)) {
        addedHolidays.push(end.clone());
        end.add(1, 'day');
      }
    }
  }

  debug.info(
    'add-days %s + %d days (%s) = %s. Added holidays: [%s]',
    from.format('DD/MM/YYYY'),
    count,
    onlyWorking ? 'only working' : 'all',
    end.format('DD/MM/YYYY'),
    addedHolidays.map(h => h.format('DD/MM/YYYY dddd')).join(', '),
  );

  return end;
};



// WEBPACK FOOTER //
// ./src/util/add-days.js